import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FullScreenLayout from "../../../../components/FullScreenLayout";
import { LoadingSpinner } from "../../../../components/LoadingSpinner";
import { TempStat } from "../../../../utils/api-objects/TempStat";
import { getAllStats } from "../../../../utils/apis/user-service";
import { useAuth } from "../../../../utils/context/AuthContext";
import { HealthPlanStats, LoginStats, MealPlanStats } from "./StatBoxes";

const Events = () => {
    const { auth } = useAuth()
    const idToken = auth.idToken
    const navigate = useNavigate()

    const [allStats, setAllStats] = useState<TempStat[]>()

    useEffect(() => {
        if (!idToken) return
        const fetchStats = async () => {
            try {
                const stats = await getAllStats(idToken)
                setAllStats(stats)
            } catch (error) {
                console.log(error)
            }
        }
        fetchStats()
    }, [idToken])

    if (!allStats) {
        return (
            <FullScreenLayout title="Eventi">
                <div className="w-full h-full flex flex-col items-center justify-center">
                    <LoadingSpinner />
                </div>
            </FullScreenLayout>
        );
    }

    return (
        <FullScreenLayout 
            title="Eventi"
            backButtonText="Torna a Analytics"
            onBack={() => navigate("/platform-experts/analytics")}
            showBackButton={true}
        >
            <div className="w-full flex flex-col space-y-6">
                <LoginStats stats={allStats} />
                <HealthPlanStats stats={allStats} />
                <MealPlanStats stats={allStats} />
            </div>
        </FullScreenLayout>
    )
}

export default Events
